import { FormErrorMessage, FormErrorMessageProps } from '@chakra-ui/react';
import React from 'react';

export const CmFormErrorMessage: React.FC<FormErrorMessageProps> = ({
  children,
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <FormErrorMessage mt={1} {...rest}>
      {children}
    </FormErrorMessage>
  );
};
